import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Wrench, ArrowRight } from "lucide-react";
import api from "@/lib/api";

/**
 * Compact 1-line banner for Director/Admin dashboard — replaces the bulky
 * PendingInstallerPanel when space is tight. Auto-hides if empty.
 */
export const PendingInstallerBanner = () => {
  const [count, setCount] = useState(null);

  useEffect(() => {
    api.get("/projects-pending-installer")
      .then((r) => setCount((r.data || []).length))
      .catch(() => setCount(0));
  }, []);

  if (count == null || count === 0) return null;

  return (
    <Link
      to="/admin/installers"
      data-testid="pending-installer-banner"
      className="flex items-center gap-3 mb-4 px-4 h-11 rounded-xl bg-amber-500/10 border border-amber-500/40 text-amber-200 hover:bg-amber-500/15 transition active:scale-[0.99]"
    >
      <Wrench size={16} className="text-amber-300 shrink-0" />
      <span className="text-[13px] font-medium truncate">
        <strong className="font-bold">{count}</strong>{" "}
        {count === 1 ? "Projekt wartet" : "Projekte warten"} auf Installations-Zuweisung
      </span>
      <ArrowRight size={14} className="ml-auto shrink-0" />
    </Link>
  );
};
